import { useMediaQuery } from './useMediaQuery';

/** Matches Tailwind `lg` breakpoint — below 1024px. */
export const MOBILE_MEDIA_QUERY = '(max-width: 1023px)';

export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_MEDIA_QUERY);
}

/** Compact layout spacing (same breakpoint as mobile sidebar toggle). */
export function useIsCompact(): boolean {
  return useMediaQuery(MOBILE_MEDIA_QUERY);
}
